import * as actionTypes from './actionTypes'
import * as API from '../../api/Admin/Category'

export const adminCatgeoryAddAction = (data) => {
    
    return dispatch => {
        dispatch({type: actionTypes.ADMIN_CATEGORY_ADD_REQUEST, payload: data})
        return API.categoryAddApi(data)
            .then(response => {             
        
                dispatch({type: actionTypes.ADMIN_CATEGORY_ADD_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.ADMIN_CATEGORY_ADD_ERROR, payload:error})    
            })
    }
}


export const adminCatgeoryUpdateAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.ADMIN_CATEGORY_UPDATE_REQUEST, payload: data})
        return API.categoryUpdateApi(data)
            .then(response => {             
        
                dispatch({type: actionTypes.ADMIN_CATEGORY_UPDATE_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.ADMIN_CATEGORY_UPDATE_ERROR, payload:error})    
            })
    }
}

export const adminCatgeoryListAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.ADMIN_CATEGORY_LIST_REQUEST, payload: data}) 
        return API.categoryListApi(data)
            .then(response => {             
                
                dispatch({type: actionTypes.ADMIN_CATEGORY_LIST_SUCCESS, payload: response.data})                
            })
            .catch(error => {
                dispatch({type: actionTypes.ADMIN_CATEGORY_LIST_ERROR, payload:error})    
            })
    }
}

export const adminCatgeoryDeleteAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.ADMIN_CATEGORY_DELETE_REQUEST, payload: data})
        return API.categoryDeleteApi(data)
            .then(response => {             
        
                dispatch({type: actionTypes.ADMIN_CATEGORY_DELETE_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.ADMIN_CATEGORY_DELETE_ERROR, payload:error})    
            })
    }
}

export const adminCatgeoryStatusAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.ADMIN_CATEGORY_STATUS_CHANGE_REQUEST, payload: data})
        return API.categoryStatusApi(data)
            .then(response => {             
        
                dispatch({type: actionTypes.ADMIN_CATEGORY_STATUS_CHANGE_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.ADMIN_CATEGORY_STATUS_CHANGE_ERROR, payload:error})    
            })
    }
}

export const adminCatgeoryOrderAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.ADMIN_CATEGORY_ORDER_CHANGE_REQUEST, payload: data})
        return API.categoryOrderApi(data)
            .then(response => {             
        
                dispatch({type: actionTypes.ADMIN_CATEGORY_ORDER_CHANGE_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.ADMIN_CATEGORY_ORDER_CHANGE_ERROR, payload:error})    
            })
    }
}






// WEBPACK FOOTER //
// ./src/actions/Admin/Category.js